import { useState } from 'react';
import { navItems, siteName } from '@/mocks/home';

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-[1400px] items-center gap-6 px-4 md:px-8">
        <a href="#top" className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-search-eye-line text-lg" />
          </span>
          <h1 className="font-heading text-lg font-bold tracking-tight text-foreground-950">
            {siteName}
          </h1>
        </a>

        <nav className="hidden items-center gap-7 md:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="text-sm text-foreground-700 transition-colors hover:text-primary-600"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto hidden items-center gap-3 lg:flex">
          <label className="flex h-9 w-56 items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3.5">
            <i className="ri-search-line text-base text-foreground-500" />
            <input
              type="text"
              placeholder="搜索事件、合集或关键词"
              className="w-full bg-transparent text-sm text-foreground-800 placeholder:text-foreground-500 focus:outline-none"
            />
          </label>
          <button
            type="button"
            className="flex h-9 items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-add-line text-base" />
            参与讨论
          </button>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="打开导航"
          className="ml-auto flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden"
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <nav className="mx-auto flex max-w-[1400px] flex-col px-4 py-3">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="border-b border-background-100 py-3 text-sm text-foreground-700 last:border-0"
              >
                {item.label}
              </a>
            ))}
            <button
              type="button"
              className="mt-3 flex h-10 items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 text-sm font-medium text-background-50"
            >
              <i className="ri-add-line text-base" />
              参与讨论
            </button>
          </nav>
        </div>
      )}
    </header>
  );
}